import { render } from "./LabelTable.vue?vue&type=template&id=8d5b76e2"
import script from "./LabelTable.vue?vue&type=script&lang=js"
export * from "./LabelTable.vue?vue&type=script&lang=js"

import "./LabelTable.vue?vue&type=style&index=0&id=8d5b76e2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__